import CustomDatePicker from 'components/CustomDatePicker/CustomDatePicker';
import { BodyMBold, BodyS } from 'components/Typography/Typography';
import React from 'react';
import DateRangeIcon from '@material-ui/icons/DateRange';
import moment from 'moment';
import { makeStyles } from '@material-ui/styles';
import styles from 'assets/jss/material-dashboard-pro-react/components/customRepeatEveryStyle';
import { Tooltip } from '@material-ui/core';
import Info from '@material-ui/icons/InfoOutlined';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IDateRowProps {
	dateValue: moment.Moment | null;
	isValidDate: (date: moment.Moment) => boolean;
	dateChanged: (date: string | moment.Moment) => void;
	label: string;
	placeholder?: string;
	tooltip?: string;
	readOnly?: boolean;
}

const DateRow = ({ dateValue, isValidDate, dateChanged, label, placeholder, tooltip, readOnly }: IDateRowProps) => {
	const classes = useStyles();

	return (
		<div>
			<div className={classes.repeatEveryDateRowWrapper}>
				<div className={classes.repeatEveryDateRowLabelWrapper}>
					<BodyMBold disableMargin color="secondary-light">
						{label}
					</BodyMBold>
				</div>
				<DateRangeIcon className={classes.iconGray} />
				<div className={classes.repeatEveryDateRowDateWrapper}>
					<CustomDatePicker
						timeFormat={false}
						value={dateValue}
						onChange={dateChanged}
						isValidDate={isValidDate}
						readOnly={readOnly}
						inputProps={{
							placeholder,
						}}
					/>
				</div>
				<ConditionalRender
					show={!!tooltip}
					onTrue={() => (
						<Tooltip
							placement={'right'}
							title={
								<BodyS color="primary-dark" disableMargin>
									{tooltip}
								</BodyS>
							}
						>
							<div className={classes.dateTooltipInfo}>
								<Info color="disabled" />
							</div>
						</Tooltip>
					)}
				/>
			</div>
		</div>
	);
};
export default DateRow;
